export const groupType = 'groupType';
export const classType = 'classType';